export const ALL_MAKES = 'All makes';
export const ALL_MODELS = 'All models';
export const ALL_TRIMS = 'All trims';

export const ALL_MAKES_LOWERCASE = ALL_MAKES.toLowerCase();
export const ALL_MODELS_LOWERCASE = ALL_MODELS.toLowerCase();
export const ALL_TRIMS_LOWERCASE = ALL_TRIMS.toLowerCase();

const SECTION_CARS = 'cars';

/**
 * Configuration: List of sections that support trim functionality.
 * To enable trims for additional sections, add them to this array.
 * Exported for testing and potential external configuration needs.
 * @example ['cars', 'commercials', 'motorbikes']
 */
export const TRIM_ENABLED_SECTIONS = [SECTION_CARS];

/**
 * Determines if trim functionality should be shown for a given section.
 * This is the single source of truth for trim feature gating.
 *
 * Trim functionality is controlled by checking if the section is in the
 * TRIM_ENABLED_SECTIONS list (currently only 'cars').
 *
 * @param sectionName - The section name to check (e.g., 'cars', 'commercials', 'motorbikes').
 *                      Case-insensitive. If undefined or empty, returns false.
 * @returns {boolean} true if trim functionality should be shown for this section, false otherwise
 *
 * @example
 * ```typescript
 * shouldShowTrims('cars')         // true
 * shouldShowTrims('CARS')         // true (case-insensitive)
 * shouldShowTrims('commercials')  // false
 * shouldShowTrims(undefined)      // false
 * ```
 */
export const shouldShowTrims = (sectionName?: string): boolean => {
  if (!sectionName) return false;

  const section = sectionName.toLowerCase();
  return TRIM_ENABLED_SECTIONS.includes(section);
};
